var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qm-indicator"},[_c('i',{staticClass:"qm-indicator-icon",class:_vm.status}),_c('span',{staticClass:"qm-indicator-message"},[_vm._v(_vm._s(_vm.displayStatus))])])
}
var staticRenderFns = []

export { render, staticRenderFns }